export default __webpack_public_path__ + "static/media/Ies_BannerREGISTRO_completo.7d6db3db.jpg";